var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("Page not found!")]),_c('div',{staticStyle:{"padding":"8px"}},[_c('o-btn',{on:{"click":_vm.close}},[_vm._v("Close")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }